import { Badge, BadgeProps, Box, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { NotificationsActive as NotificationIcon } from '@mui/icons-material';
import { useAlerts } from '../../../../hooks/use-alerts';
import { useSlideout } from '../../../../hooks/use-slideout';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { useCallback } from 'react';

const NotificationContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  paddingRight: '20px'
});

const ActionMenu = styled(IconButton)(({ theme }) => ({
  width: 48,
  height: 48,
  margin: '11px 0 11px 0',
  backgroundColor: '#004763',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#265D7C'
  },
  '&:focus-visible': {
    border: '2px solid #1EB9FB'
  },
  '&.open': {
    backgroundColor: '#0675DD',
    '&:hover': {
      backgroundColor: '#0675DD'
    }
  }
}));

const NotificationBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    marginTop: 6,
    marginRight: -6,
    backgroundColor: '#1EB9FB',
    color: '#032F40'
  }
}));

export default function AlertButton() {
  const { isVisibleAlerts } = useSlideout();
  const { alertsActive } = useAlerts();
  const { publish } = useEventBus();

  const showAlerts = useCallback(() => {
    if (!isVisibleAlerts) publish({ messageType: 'showAlerts' });
  }, [publish, isVisibleAlerts]);

  return (
    <NotificationContainer>
      <NotificationBadge badgeContent={alertsActive.length} showZero={false} overlap='circular'>
        <ActionMenu className={isVisibleAlerts ? 'open' : ''} onClick={showAlerts}>
          <NotificationIcon />
        </ActionMenu>
      </NotificationBadge>
    </NotificationContainer>
  );
}
